import { TUIChatEngine } from '@tencentcloud/chat-uikit-engine';
import Server from '@/TUIKit/server';
import TUIComponents from '@/views/session/components';

const TUIChatKit = new Server();

export { TUIChatKit, TUIChatEngine, TUIComponents };
